import { FlexContainer, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import useTranslation from 'Hooks/useTranslation';
import { defaultProps, SummaryCardHeaderProps } from './types';
import * as Styled from './styles';

const SummaryCardHeader: React.FC<SummaryCardHeaderProps> = ({
  header,
  subheader,
  handleOnEdit,
  additionalIcon,
}) => {
  const { t } = useTranslation(locizeNS.VALIDATIONS);
  return (
    <Styled.SummaryCardHeader>
      <FlexContainer direction="column" gap="dimension_04">
        {header && (
          <Text type="paragraphs" color="dark" size="S_L_M">
            {header}
          </Text>
        )}
        {subheader && (
          <Text type="paragraphs" color="dark" size="S_S_M">
            {subheader.toString()}
          </Text>
        )}
      </FlexContainer>
      <Styled.EditButton data-testid="editButton" onClick={handleOnEdit}>
        {t('Button.edit')}
      </Styled.EditButton>
      {additionalIcon && <Styled.AdditionalIcon src={additionalIcon} alt="additional-icon" />}
    </Styled.SummaryCardHeader>
  );
};

SummaryCardHeader.defaultProps = defaultProps;

export default SummaryCardHeader;
